/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DatabaseEntriesCopyRequest
 */
export interface DatabaseEntriesCopyRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof DatabaseEntriesCopyRequest
     */
    entryIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof DatabaseEntriesCopyRequest
     */
    targetDatabaseId: string;
    /**
     * Pflicht, wenn das Ziel eine Unterdatenbank ist: der Datensatz der Eltern-Datenbank, zu dem die Kopien gehoeren.
     * @type {string}
     * @memberof DatabaseEntriesCopyRequest
     */
    targetParentEntryId?: string;
}

/**
 * Check if a given object implements the DatabaseEntriesCopyRequest interface.
 */
export function instanceOfDatabaseEntriesCopyRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "entryIds" in value;
    isInstance = isInstance && "targetDatabaseId" in value;

    return isInstance;
}

export function DatabaseEntriesCopyRequestFromJSON(json: any): DatabaseEntriesCopyRequest {
    return DatabaseEntriesCopyRequestFromJSONTyped(json, false);
}

export function DatabaseEntriesCopyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseEntriesCopyRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entryIds': json['entryIds'],
        'targetDatabaseId': json['targetDatabaseId'],
        'targetParentEntryId': !exists(json, 'targetParentEntryId') ? undefined : json['targetParentEntryId'],
    };
}

export function DatabaseEntriesCopyRequestToJSON(value?: DatabaseEntriesCopyRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entryIds': value.entryIds,
        'targetDatabaseId': value.targetDatabaseId,
        'targetParentEntryId': value.targetParentEntryId,
    };
}

